<div class="content-block">
  <article class="article " style="margin-top:1rem">

    <div class="title-container">
      <button class="btn btn-back" (click)="back()"><i class="fas fa-caret-left"></i> Back</button>
      <div style="flex: 10;">
        <h2>Location Management</h2>
      </div>
      <div style="flex:1;justify-content: flex-end;display: flex;">
        <div class="add" (click)="add()" *ngIf="!readOnly">
          <i class="fa fa-plus" aria-hidden="true"></i>
        </div>
      </div>
    </div>




    <form class="card-title form-column " style="width: 100%;padding: 0.5rem;margin-top: 0.5rem;" (submit)="rebind()">
      <div class="form-row borderless " style="padding:0px;margin:0px;">

      <div class="col-md-3">
        <label>Name</label>
        <input type="text" style="width: 100%;" name="name" [(ngModel)]="filter.name" />
      </div>
        <div class="col-md-3"></div>

        <div class="col-md-3 col-sm-6"></div>
         <div class="col-md-3 col-sm-6">
            <label></label>
          <div class="btn-container" style="justify-content: flex-end;min-height: 57px;">

            <button class="btn btn-secondary" style="margin-right:1rem" (click)="resetFilters()">Reset</button>
            <button class="btn btn-primary" style="margin-right:1.25rem" value="Refresh">Refresh</button>
          </div>
        </div>

      </div>

    </form>

    <app-loading-icon *ngIf="loading"></app-loading-icon>

    <div class="form-column borderless" style="display: block;">

      <ngx-datatable [count]="page.totalElements" [offset]="page.pageNumber" [limit]="page.size" [headerHeight]="50"
        [footerHeight]="50" (page)='setPage($event)' (sort)="onSort($event)" class="material" [rows]="rows"
        [rowClass]="getRowClass" [columnMode]="'force'" [externalPaging]="true" [externalSorting]="true"
        [rowHeight]="'auto'">

        <ngx-datatable-column name="Name" prop="name">
          <ng-template let-value="value" ngx-datatable-cell-template>
            <div>{{ value }}</div>
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Address 1" prop="address_1">
          <ng-template let-value="value" ngx-datatable-cell-template>
            <div>{{ value }}</div>
          </ng-template>
        </ngx-datatable-column>


        <ngx-datatable-column name="Address 2" prop="address_2">
          <ng-template let-value="value" ngx-datatable-cell-template>
            <div>{{ value }}</div>
          </ng-template>
        </ngx-datatable-column>


        <ngx-datatable-column name="Address 3" prop="address_3">
          <ng-template let-value="value" ngx-datatable-cell-template>
            <div>{{ value }}</div>
          </ng-template>
        </ngx-datatable-column>


        <ngx-datatable-column name="Address 4" prop="address_3">
          <ng-template let-value="value" ngx-datatable-cell-template>
            <div>{{ value }}</div>
          </ng-template>
          </ngx-datatable-column>
          
          
          <ngx-datatable-column name="Postcode" prop="postcode">
            <ng-template let-value="value" ngx-datatable-cell-template>
              <div>{{ value }}</div>
            </ng-template>
          </ngx-datatable-column>
          
          
          <ngx-datatable-column name="View" *ngIf="!readOnly">
            <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
              <span style="padding:1%" (click)="view(row)" class="edit-option"><i class="fa fa-map-marker"
                  aria-hidden="true"></i>
                View Sublocations</span>
            </ng-template>
          </ngx-datatable-column> 

          <ngx-datatable-column name="Option" *ngIf="!readOnly">
            <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
              <span style="padding:1%" (click)="edit(row)" class="edit-option danger "><i class="fa fa-pencil"
                  aria-hidden="true"></i>
                Edit</span>
            </ng-template>
          </ngx-datatable-column>
          
          </ngx-datatable>
          </div>
          </article>
          </div>